import axios from '@/lib/axios';
import { SalesOrder } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 2500. 受注案件BoardProject連携登録
 * [POST] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_board_project
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  url: string;
};
const createSalesOrderBoardProject = (props: Props): Promise<SalesOrder> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_board_project`,
    props
  );
};

export const useCreateSalesOrderBoardProject = () => {
  return useMutation({
    mutationFn: createSalesOrderBoardProject,
  });
};
